interface Config {
  ROUTES: {
    systemadmin: string;
    researcher: string;
    etl: string;
    public: string;
    login: string;
    logout: string;
    noAccess: string;
  };
}

const RESEARCHER_PATH = "/researcher";
const PUBLIC_PATH = "/public";
const SYSTEM_ADMIN_PATH = "/systemadmin";
const ETL_PATH = "/etl";

export const config: Config = {
  ROUTES: {
    systemadmin: SYSTEM_ADMIN_PATH,
    researcher: RESEARCHER_PATH,
    etl: ETL_PATH,
    public: PUBLIC_PATH,
    login: "/login",
    logout: "/logout",
    noAccess: "/no-access",
  },
};

export enum Roles {
  STUDY_RESEARCHER = "RESEARCHER",
  TENANT_VIEWER = "TENANT_VIEWER",
}

export const STUDY_ROLES: { [key: string]: string } = {
  [Roles.STUDY_RESEARCHER]: "Researcher",
};

export const TENANT_ROLES: { [key: string]: string } = {
  [Roles.TENANT_VIEWER]: "Viewer",
};

export const ALP_USER_ADMIN = "ALP_USER_ADMIN";
export const ALP_DASHBOARD_VIEWER = "ALP_DASHBOARD_VIEWER";
export const STUDY_WRITE_DQD_RESEARCHER = "STUDY_WRITE_DQD_RESEARCHER";
export const STUDY_RESULTS_READ_RESEARCHER = "STUDY_RESULTS_READ_RESEARCHER";
export const ETL_MAPPING_CONTRIBUTOR = "ETL_MAPPING_CONTRIBUTOR";

export const ALP_ROLES: { [key: string]: string } = {
  [ALP_USER_ADMIN]: "User Admin",
  [ALP_DASHBOARD_VIEWER]: "Dashboard Viewer",
  [STUDY_WRITE_DQD_RESEARCHER]: "Job Runner",
  [STUDY_RESULTS_READ_RESEARCHER]: "View Study Results",
  [ETL_MAPPING_CONTRIBUTOR]: "ETL Mapping Contributor",
};

export const ALP_SYSTEM_ADMIN = "ALP_SYSTEM_ADMIN";

export const DATA_ADMIN_ROLES: { [key: string]: string } = {
  [ALP_SYSTEM_ADMIN]: "Admin",
};

export const FEATURE_ATLAS = "atlas";
export const FEATURE_PYTHIA = "pythia";
export const FEATURE_DATASET_FILTER = "datasetFilter";
export const FEATURE_DATASET_SEARCH = "datasetSearch";
export const FEATURE_FHIR_SERVER = "fhirServer";
export const FEATURE_MAPPING_SUGGESTION = "mappingSuggestion";
export const FEATURE_DOCKER_LOGS = "d2eLogs";
export const FEATURE_ADMIN_ONLY_SHARING = "adminOnlySharing";
export const FEATURE_AI_ASSISTANT = "aiAssistant";

export * from "./FeatureGate";
